
import Cookies from 'js-cookie'

const ACCESSTOKEN_KEY = 'user_auth_token'
const AUTH_DATA_KEY = 'user_auth_key'

const auth = {
  refresh_token: null,
  code: null,
  authData: null
}

auth.gettoken = function() {
  return this.refresh_token || Cookies.get(ACCESSTOKEN_KEY)
}

auth.setcode = function(t) {
  this.code = t
}

auth.settoken = function(t) {
  this.refresh_token = t
  return Cookies.set(ACCESSTOKEN_KEY, t)
}

auth.save = function(value) {
  this.refresh_token = value.accessToken
  this.authData = value
  Cookies.set(ACCESSTOKEN_KEY, value.accessToken)
  Cookies.set(AUTH_DATA_KEY, JSON.stringify(value))
}

auth.clean = function() {
  this.refresh_token = null
  this.authData = null
  Cookies.remove(AUTH_DATA_KEY)
  Cookies.remove(ACCESSTOKEN_KEY)
}

auth.getAuthData = function() {
  this.authData = JSON.parse(Cookies.get(AUTH_DATA_KEY)) || null
  if (this.authData) {
    this.refresh_token = this.authData.accessToken
  }
  return this.authData
}

export default auth
